import {areProductScreensAvailable, initializeProductSlider} from "layouts/_product_screens";
import "./resources_custom.scss";

document.addEventListener("DOMContentLoaded", () => {
  if (areProductScreensAvailable()) {
    initializeProductSlider();
  }

  const form = document.getElementById("form") as HTMLFormElement;
  const submitButton = document.getElementById("id_submit") as HTMLInputElement;
  if (!form || !submitButton) {
    return;
  }

  form.addEventListener("submit", function(ev) {
    submitButton.setAttribute("disabled", "disabled");
    submitButton.value = "Please wait...";
  });
});
